import { render } from "./MngMaterial.vue?vue&type=template&id=19002d61&scoped=true&ts=true"
import script from "./MngMaterial.vue?vue&type=script&lang=ts"
export * from "./MngMaterial.vue?vue&type=script&lang=ts"

import "./MngMaterial.vue?vue&type=style&index=0&id=19002d61&scoped=true&lang=css"
import "./MngMaterial.vue?vue&type=style&index=1&id=19002d61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19002d61"]])

export default __exports__